import useWebSocket, { ReadyState } from 'react-use-websocket'
import { useEffect, useState } from 'react'
import { useCharacters } from '../contexts/Characters'
import { env } from '../utilities/helpers'

export function usePersistentWebSocket() {
  const characters = useCharacters()
  const [socketUrl, setSocketUrl] = useState(env.BACKEND_WEBSOCKET_URL)
  const { sendMessage, lastMessage, readyState, getWebSocket } = useWebSocket(socketUrl, {
    shouldReconnect: () => true,
    reconnectAttempts: Infinity,
    reconnectInterval: 5000,
  })

  useEffect(() => {
    const tryReconnect = () => setSocketUrl(`${env.BACKEND_WEBSOCKET_URL}?t=${Date.now()}`)

    const handleOnline = () => tryReconnect()
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') tryReconnect()
    }


    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('online', handleOnline)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('online', handleOnline)
    }
  }, [getWebSocket])

  useEffect(() => {
    if (readyState === ReadyState.OPEN) {
      sendMessage(JSON.stringify({
        type: 'reconnect',
        payload: { character: characters.$state.current }
      }))
    }
  }, [readyState])

  return { sendMessage, lastMessage, readyState }
}